<div
  class="d-flex user-container size-limit"
  [class.table-size-limit]="hasTableSizeLimit"
  [class.connection-size-limit]="hasConnectionSizeLimit"
>
  <app-small-profile-image
    [profileImage]="userInfo.userImage"
    [accountStatus]="userInfo.userStatus"
    [dataTestId]="'user-avatar-' + srtIndex"
    [link]="getLink(userInfo)"
  ></app-small-profile-image>

  <div class="align-self-center ms-2">
    <h5 class="my-0">
      <app-profile-link
        [dataTestId]="'username-' + srtIndex"
        [cssStyles]="'username'"
        [status]="userInfo.userStatus"
        [userId]="userInfo.userId"
        [text]="userInfo.userName"
      ></app-profile-link>
    </h5>
  </div>
</div>
